export { default as LogoAladin } from './logo-aladin.vue'
export { default as LogoAladinQua } from './logo-aladin-qua.vue'
export { default as LogoAladinDev } from './logo-aladin-dev.vue'
export { default as LogoAladinTest } from './logo-aladin-test.vue'
export { default as LogoGammVert } from './logo-gamm-vert.vue'
export { default as LogoJardiland } from './logo-jardiland.vue'
